export function formatDate(date: Date | string | undefined, lang: string = 'en-GB') {
    if (!date) return '--/--/----';
    const d = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(d.getTime())) return '--/--/----';
    const localized = d.toLocaleDateString(lang, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
    return localized.replace(/[^0-9]/g, '/');
}
